import React, { useRef, useEffect, useState } from "react";

export default function ZeichenCanvas({ gespeicherteZeichnung, canvasRefCallback }) {
  const canvasRef = useRef(null);
  const zeichnenAktiv = useRef(false);
  const letzterPunkt = useRef(null);
  const [zoom, setZoom] = useState(1);
  const BREITE = 2000;
  const HOEHE = 1500;

  // Canvas-Referenz nach außen geben
  useEffect(() => {
    if (canvasRefCallback && canvasRef.current) {
      canvasRefCallback(canvasRef.current);
    }
  }, [canvasRefCallback]);

  // Gespeicherte Zeichnung laden
  useEffect(() => {
    if (!gespeicherteZeichnung || !canvasRef.current) return;
    const img = new Image();
    img.onload = () => {
      const ctx = canvasRef.current?.getContext("2d");
      if (ctx) { ctx.clearRect(0, 0, BREITE, HOEHE); ctx.drawImage(img, 0, 0); }
    };
    img.src = gespeicherteZeichnung;
  }, [gespeicherteZeichnung]);

  const getPos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const scaleX = BREITE / rect.width;
    const scaleY = HOEHE / rect.height;
    const src = e.touches ? e.touches[0] : e;
    return { x: (src.clientX - rect.left) * scaleX, y: (src.clientY - rect.top) * scaleY };
  };

  const startZeichnen = (e) => {
    e.preventDefault();
    zeichnenAktiv.current = true;
    letzterPunkt.current = getPos(e);
  };

  const waehrendZeichnen = (e) => {
    e.preventDefault();
    if (!zeichnenAktiv.current || !canvasRef.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const pos = getPos(e);
    ctx.beginPath();
    ctx.moveTo(letzterPunkt.current.x, letzterPunkt.current.y);
    ctx.lineTo(pos.x, pos.y);
    ctx.strokeStyle = "#1a3558";
    ctx.lineWidth = 3;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.stroke();
    letzterPunkt.current = pos;
  };

  const stopZeichnen = () => { zeichnenAktiv.current = false; };

  const allesLoeschen = () => {
    const ctx = canvasRef.current?.getContext("2d");
    if (ctx) ctx.clearRect(0, 0, BREITE, HOEHE);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
      <div style={styles.toolbar}>
        <button style={styles.btn} onClick={() => setZoom(z => Math.min(+(z + 0.25).toFixed(2), 3))}>🔍+</button>
        <span style={styles.zoomLabel}>{Math.round(zoom * 100)}%</span>
        <button style={styles.btn} onClick={() => setZoom(z => Math.max(+(z - 0.25).toFixed(2), 0.25))}>🔍-</button>
        <button style={styles.btn} onClick={() => setZoom(1)}>1:1</button>
        <button style={{ ...styles.btn, backgroundColor: "#ea4335", color: "white" }} onClick={allesLoeschen}>🗑️ Löschen</button>
      </div>
      <div style={{ flex: 1, overflow: "scroll", backgroundColor: "#ccc" }}>
        <div style={{ width: BREITE * zoom, height: HOEHE * zoom }}>
          <canvas
            ref={canvasRef}
            width={BREITE}
            height={HOEHE}
            style={{ transform: `scale(${zoom})`, transformOrigin: "top left", cursor: "crosshair", backgroundColor: "white", display: "block", touchAction: "none" }}
            onMouseDown={startZeichnen}
            onMouseMove={waehrendZeichnen}
            onMouseUp={stopZeichnen}
            onMouseLeave={stopZeichnen}
            onTouchStart={startZeichnen}
            onTouchMove={waehrendZeichnen}
            onTouchEnd={stopZeichnen}
          />
        </div>
      </div>
    </div>
  );
}

const styles = {
  toolbar: { display: "flex", gap: "0.3rem", alignItems: "center", padding: "0.4rem 0.6rem", backgroundColor: "#f8f9fa", borderBottom: "1px solid #ddd", flexShrink: 0 },
  btn: { padding: "0.2rem 0.5rem", backgroundColor: "#f0f2f5", border: "1px solid #ddd", borderRadius: "4px", cursor: "pointer", fontSize: "0.8rem" },
  zoomLabel: { fontSize: "0.75rem", minWidth: "38px", textAlign: "center", color: "#555" },
};
